import { InputProps } from 'formik-antd';
import InputStyled from './styles';

type Props = InputProps & {};

const InputField = (props: Props) => {
  return <InputStyled {...props} />;
};

export default InputField;
